import React, { useMemo } from "react";
import Lottie from "lottie-react";
import MainLoader from "../../assets/animations/MainLoader.json"; // Ensure JSON module support in tsconfig.json

const Loader: React.FC = () => {
  const animationOptions = useMemo(() => ({ animationData: MainLoader, loop: true }), []);

  return (
    <div className="flex items-center justify-center h-screen">
      <Lottie {...animationOptions} style={{ width: 200, height: 200 }} />
    </div>
  );
};

export default Loader;
